import { useEffect, useState } from 'react';
import { WifiOff, RefreshCw, AlertTriangle } from 'lucide-react';
import { onSyncError, retrySync, type SyncErrorEvent } from '../store/syncEngine';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [syncError, setSyncError] = useState<SyncErrorEvent | null>(null);
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline  = () => { setOffline(false); setSyncError(null); };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online',  goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online',  goOnline);
    };
  }, []);

  useEffect(() => {
    return onSyncError(e => setSyncError(e));
  }, []);

  const handleRetry = async () => {
    setRetrying(true);
    await retrySync();
    setRetrying(false);
    // Başarılıysa flushQueue remaining=0 → emitSyncError çağrılmaz → banner kapanmaz
    // Manuel kapat:
    setTimeout(() => setSyncError(null), 1500);
  };

  if (!offline && !syncError) return null;

  if (offline) {
    return (
      <div className="fixed top-0 inset-x-0 z-[200] flex items-center justify-center gap-2 px-4 py-2 bg-amber-500/90 backdrop-blur-sm text-amber-950 text-xs font-semibold shadow-lg">
        <WifiOff className="w-3.5 h-3.5 flex-shrink-0" />
        <span>Çevrimdışı — veriler yerel olarak kaydedilecek, bağlantı kurulunca senkronize edilecek.</span>
      </div>
    );
  }

  // syncError banner — çevrimiçi ama sync başarısız
  return (
    <div className="fixed top-0 inset-x-0 z-[200] flex items-center justify-center gap-3 px-4 py-2 bg-red-500/90 backdrop-blur-sm text-white text-xs font-semibold shadow-lg">
      <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{syncError!.pendingCount} değişiklik senkronize edilemedi.</span>
      <button
        onClick={handleRetry}
        disabled={retrying}
        className="flex items-center gap-1 px-2 py-0.5 rounded bg-white/20 hover:bg-white/30 border border-white/30 cursor-pointer disabled:opacity-50 transition-colors"
      >
        <RefreshCw className={`w-3 h-3 ${retrying ? 'animate-spin' : ''}`} />
        {retrying ? 'Deneniyor…' : 'Tekrar Dene'}
      </button>
      <button onClick={() => setSyncError(null)} className="text-white/60 hover:text-white cursor-pointer ml-1">✕</button>
    </div>
  );
}
